// Copyright (c) 2017 Deere & Company

import ClaimForApproval, {getDefaultState as getClaimForApprovalDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval';
import KeyValuePairCollection, {getDefaultState as getKeyValuePairCollectionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import TcsmApproveDenyModal, {getDefaultState as getTcsmApproveDenyModalDefaultState} from '../../wip/state/tcsm-approve-deny-modal';
import t from 'tcomb';

const State = t.struct({
    claim: ClaimForApproval,
    modal: TcsmApproveDenyModal,
    spaTypes: KeyValuePairCollection
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        claim: getClaimForApprovalDefaultState(),
        modal: getTcsmApproveDenyModalDefaultState(),
        spaTypes: getKeyValuePairCollectionDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/state/index.js